import React, { useState } from "react";
import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";
import "./Gallery.css";

// Gallery images from 2024 folder
import img2024_1 from "../../images/gallery/2024/1D6A1173.webp";
import img2024_2 from "../../images/gallery/2024/1D6A1520.webp";
import img2024_3 from "../../images/gallery/2024/1D6A1731.webp";
import img2024_4 from "../../images/gallery/2024/1D6A1946.webp";
import img2024_5 from "../../images/gallery/2024/1D6A2060.webp";
import img2024_6 from "../../images/gallery/2024/1D6A2170.webp";
import img2024_7 from "../../images/gallery/2024/1D6A2174.webp";
import img2024_8 from "../../images/gallery/2024/1D6A2300.webp";
import img2024_9 from "../../images/gallery/2024/1D6A2306.webp";
import img2024_10 from "../../images/gallery/2024/1D6A2386.webp";
import img2024_11 from "../../images/gallery/2024/1D6A2406.webp";
import img2024_12 from "../../images/gallery/2024/1D6A2527.webp";

// Gallery images from 2025 folder
import img2025_1 from "../../images/gallery/2025/8Y6A8985.webp";
import img2025_2 from "../../images/gallery/2025/8Y6A9000.webp";
import img2025_3 from "../../images/gallery/2025/8Y6A9007.webp";
import img2025_4 from "../../images/gallery/2025/8Y6A9024.webp";
import img2025_5 from "../../images/gallery/2025/8Y6A9028.webp";
import img2025_6 from "../../images/gallery/2025/8Y6A9031.webp";
import img2025_7 from "../../images/gallery/2025/8Y6A9037.webp";
import img2025_8 from "../../images/gallery/2025/8Y6A9039.webp";
import img2025_9 from "../../images/gallery/2025/8Y6A9045.webp";
import img2025_10 from "../../images/gallery/2025/8Y6A9068.webp";
import img2025_11 from "../../images/gallery/2025/8Y6A9085.webp";
import img2025_12 from "../../images/gallery/2025/8Y6A9096.webp";

// Video data for 2024
const videos2024 = [
  { id: "iES3HZxrtoA", title: "Cash Flow Summit 2024 - Video 1" },
  { id: "jgvm0wE_dMQ", title: "Cash Flow Summit 2024 - Video 2" },
  { id: "NIVlFL0oQ7I", title: "Cash Flow Summit 2024 - Video 3" },
  { id: "jT8lbgfPIxs", title: "Cash Flow Summit 2024 - Video 4" },
  { id: "YBGyjsLlds8", title: "Cash Flow Summit 2024 - Video 5" },
  { id: "9N0vgZ4vMFg", title: "Cash Flow Summit 2024 - Video 6" },
];

// Video data for 2025
const videos2025 = [
  { id: "Hm2NYshEANs", title: "Cash Flow Summit 2025 - Video 1" },
  { id: "KpgY8EsGE9U", title: "Cash Flow Summit 2025 - Video 2" },
  { id: "lBnr__mHW10", title: "Cash Flow Summit 2025 - Video 3" },
  { id: "Vd5qqQEwALQ", title: "Cash Flow Summit 2025 - Video 4" },
  { id: "SLdskW10EGE", title: "Cash Flow Summit 2025 - Video 5" },
  { id: "Rpauz6dBnpM", title: "Cash Flow Summit 2025 - Video 6" },
];

// Gallery data for 2024
const gallery2024 = [
  { id: 1, image: img2024_1, title: "Event 2024 - Image 1", type: "image" },
  { id: 2, image: img2024_2, title: "Event 2024 - Image 2", type: "image" },
  { id: 3, image: img2024_3, title: "Event 2024 - Image 3", type: "image" },
  { id: 4, image: img2024_4, title: "Event 2024 - Image 4", type: "image" },
  { id: 5, image: img2024_5, title: "Event 2024 - Image 5", type: "image" },
  { id: 6, image: img2024_6, title: "Event 2024 - Image 6", type: "image" },
  { id: 7, image: img2024_7, title: "Event 2024 - Image 7", type: "image" },
  { id: 8, image: img2024_8, title: "Event 2024 - Image 8", type: "image" },
  { id: 9, image: img2024_9, title: "Event 2024 - Image 9", type: "image" },
  { id: 10, image: img2024_10, title: "Event 2024 - Image 10", type: "image" },
  { id: 11, image: img2024_11, title: "Event 2024 - Image 11", type: "image" },
  { id: 12, image: img2024_12, title: "Event 2024 - Image 12", type: "image" },
  // Add videos to gallery
  ...videos2024.map((video, index) => ({
    id: `video-${index + 1}`,
    videoId: video.id,
    title: video.title,
    type: "video",
  })),
];

// Gallery data for 2025
const gallery2025 = [
  { id: 1, image: img2025_1, title: "Event 2025 - Image 1", type: "image" },
  { id: 2, image: img2025_2, title: "Event 2025 - Image 2", type: "image" },
  { id: 3, image: img2025_3, title: "Event 2025 - Image 3", type: "image" },
  { id: 4, image: img2025_4, title: "Event 2025 - Image 4", type: "image" },
  { id: 5, image: img2025_5, title: "Event 2025 - Image 5", type: "image" },
  { id: 6, image: img2025_6, title: "Event 2025 - Image 6", type: "image" },
  { id: 7, image: img2025_7, title: "Event 2025 - Image 7", type: "image" },
  { id: 8, image: img2025_8, title: "Event 2025 - Image 8", type: "image" },
  { id: 9, image: img2025_9, title: "Event 2025 - Image 9", type: "image" },
  { id: 10, image: img2025_10, title: "Event 2025 - Image 10", type: "image" },
  { id: 11, image: img2025_11, title: "Event 2025 - Image 11", type: "image" },
  { id: 12, image: img2025_12, title: "Event 2025 - Image 12", type: "image" },
  // Add videos to gallery
  ...videos2025.map((video, index) => ({
    id: `video-${index + 1}`,
    videoId: video.id,
    title: video.title,
    type: "video",
  })),
];

const Gallery = () => {
  const [activeTab, setActiveTab] = useState("2024");
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [lightboxIndex, setLightboxIndex] = useState(0);
  const [videoModalOpen, setVideoModalOpen] = useState(false);
  const [selectedVideo, setSelectedVideo] = useState(null);

  const handleTabChange = (year) => {
    setActiveTab(year);
    setLightboxOpen(false); // Close lightbox when switching tabs
    setVideoModalOpen(false); // Close video modal when switching tabs
  };

  const currentGallery = activeTab === "2024" ? gallery2024 : gallery2025;

  // Convert gallery data to lightbox format (only images)
  const lightboxSlides = currentGallery
    .filter((item) => item.type === "image")
    .map((item) => ({
      src: item.image,
      alt: item.title,
    }));

  const handleImageClick = (index) => {
    // Find the actual index in the filtered images array
    const imageItems = currentGallery.filter((item) => item.type === "image");
    const imageIndex = imageItems.findIndex(
      (item) => item.id === currentGallery[index].id
    );
    if (imageIndex !== -1) {
      setLightboxIndex(imageIndex);
      setLightboxOpen(true);
    }
  };

  const handleVideoClick = (videoId, title) => {
    setSelectedVideo({ id: videoId, title });
    setVideoModalOpen(true);
  };

  return (
    <section className="gallery-section section-padding">
      <div className="container">
        <div className="row">
          <div className="col-12">
            <div className="gallery-header text-center">
              <h2 className="gallery-title">Photo Gallery</h2>
              <p className="gallery-subtitle">
                Explore our memorable moments from past events
              </p>
            </div>

            {/* Tabs */}
            <div className="gallery-tabs">
              <div className="tab-buttons">
                <button
                  className={`tab-button ${activeTab === "2024" ? "active" : ""}`}
                  onClick={() => handleTabChange("2024")}
                >
                  2024
                </button>
                <button
                  className={`tab-button ${activeTab === "2025" ? "active" : ""}`}
                  onClick={() => handleTabChange("2025")}
                >
                  2025
                </button>
              </div>
            </div>

            {/* Gallery Grid */}
            <div className="gallery-grid">
              {currentGallery.map((item, index) => {
                if (item.type === "video") {
                  const thumbnailUrl = `https://img.youtube.com/vi/${item.videoId}/maxresdefault.jpg`;
                  return (
                    <div
                      key={item.id}
                      className="gallery-item gallery-item-video"
                      onClick={() => handleVideoClick(item.videoId, item.title)}
                    >
                      <div className="gallery-image-wrapper">
                        <div className="gallery-video-thumbnail">
                          <img
                            src={thumbnailUrl}
                            alt={item.title}
                            className="gallery-video-thumbnail-img"
                            onError={(e) => {
                              // Fallback to medium quality thumbnail if maxresdefault fails
                              e.target.src = `https://img.youtube.com/vi/${item.videoId}/hqdefault.jpg`;
                            }}
                          />
                        </div>
                        <div className="gallery-video-play-icon">
                          <svg
                            width="80"
                            height="80"
                            viewBox="0 0 24 24"
                            fill="white"
                          >
                            <path d="M8 5v14l11-7z" />
                          </svg>
                        </div>
                        <div className="gallery-overlay">
                          <div className="gallery-content">
                            <h4 className="gallery-item-title">{item.title}</h4>
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                }
                return (
                  <div
                    key={item.id}
                    className="gallery-item"
                    onClick={() => handleImageClick(index)}
                  >
                    <div className="gallery-image-wrapper">
                      <img
                        src={item.image}
                        alt={item.title}
                        className="gallery-image"
                      />
                      <div className="gallery-overlay">
                        <div className="gallery-content">
                          <h4 className="gallery-item-title">{item.title}</h4>
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>

      {/* Lightbox Carousel */}
      <Lightbox
        open={lightboxOpen}
        close={() => setLightboxOpen(false)}
        index={lightboxIndex}
        slides={lightboxSlides}
        on={{ view: ({ index }) => setLightboxIndex(index) }}
      />

      {/* Video Modal */}
      {videoModalOpen && selectedVideo && (
        <div
          className="gallery-video-modal"
          onClick={() => setVideoModalOpen(false)}
        >
          <div
            className="gallery-video-modal-content"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              className="gallery-video-modal-close"
              onClick={() => setVideoModalOpen(false)}
            >
              ×
            </button>
            <div className="gallery-video-modal-wrapper">
              <iframe
                src={`https://www.youtube.com/embed/${selectedVideo.id}?autoplay=1`}
                title={selectedVideo.title}
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerPolicy="strict-origin-when-cross-origin"
                allowFullScreen
                className="gallery-video-modal-iframe"
              ></iframe>
            </div>
          </div>
        </div>
      )}
    </section>
  );
};

export default Gallery;

